import { render, staticRenderFns } from "./ListOutgoingDocuments.vue?vue&type=template&id=0d01f33e&scoped=true&"
import script from "./ListOutgoingDocuments.vue?vue&type=script&lang=js&"
export * from "./ListOutgoingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListOutgoingDocuments.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ListOutgoingDocuments.vue?vue&type=style&index=1&id=0d01f33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01f33e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VDataTable,VIcon,VTooltip})
